<template>
  <div>
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3">
          {{
            $t(
              isNew
                ? "CRUD.newInfo"
                : savable
                ? "CRUD.editInfo"
                : "CRUD.viewInfo",
              [$t("Materials.ObjectName")]
            )
          }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="
                  $emit('mode', null);
                  $emit('input', null);
                "
                >fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$t("Materials.ObjectName")]) }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
          <ValidationObserver ref="observer">
            <v-container>
              <!-- 商品编码 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("Material.Fields.material_code") + $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <!-- <v-col cols="9" md="7" v-if="savable">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('Material.Fields.material_code')"
                      rules="required"
                    >
                      <v-text-field
                        single-line
                        v-model="material.material_code"
                        :hint="isNew ? '' : $t('Material.codeHint')"
                        :error-messages="
                          $resparse
                            .getErrorMsgs(serverErrors, 'material_code')
                            .concat(errors)
                        "
                      >
                        <template v-slot:message="{ key, message }">
                          <div :class="key == 0 ? 'danger--text' : ''">
                            {{ message }}
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col> -->
                <v-col cols="9" md="7">
                  {{ material.material_code }}
                </v-col>
              </v-row>
              <!-- 商品名称 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("Material.Fields.material_name") + $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Material.Fields.material_name')"
                    rules="required"
                  >
                    <v-text-field
                      single-line
                      v-model="material.material_name"
                      :hint="isNew ? '' : $t('Material.nameHint')"
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'material_name')
                          .concat(errors)
                      "
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ material.material_name }}
                </v-col>
              </v-row>
              <!-- 默认图片 -->
              <v-row v-if="MaterialImage">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("Material.Fields.material_img") + $t("Global.colon") }}
                  <Required :show="false" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7">
                  <v-card v-if="material_img" max-width="240">
                    <v-img
                      :src="material_img"
                      @click.stop="$showFullscreenImages([material_img])"
                    >
                      <v-tooltip right v-if="savable && material_img">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            color="secondary"
                            class="pa-2 float-right"
                            @click.stop="
                              !material_img.startsWith('data:image/') &&
                              material_img == material.material_img
                                ? (material.material_img = material_img = null)
                                : (material_img = null)
                            "
                          >
                            fa-times
                          </v-icon>
                        </template>
                        <span> {{ $t("Material.delImg") }}</span>
                      </v-tooltip>
                    </v-img>
                  </v-card>
                  <v-file-input
                    ref="material_img_file"
                    v-if="savable"
                    show-size
                    prepend-icon="fa-camera"
                    accept="image/png, image/jpeg"
                    persistent-hint
                    :placeholder="$t('Material.imgPlaceholder')"
                    :hint="$t('Material.imgHint')"
                    :rules="imgRules"
                    v-model="material_img_file"
                  >
                  </v-file-input>
                </v-col>
              </v-row>
              <!-- 图片集 -->
              <v-row v-if="MaterialImage">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Material.Fields.material_album") + $t("Global.colon")
                  }}
                  <Required :show="false" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7">
                  <v-card
                    height="320"
                    v-if="material_album && material_album.length > 0"
                  >
                    <v-carousel hide-delimiters cycle height="320">
                      <v-carousel-item
                        v-for="(item, i) in material_album"
                        :key="i"
                        :src="item"
                        @click.stop="$showFullscreenImages(material_album, i)"
                      >
                        <v-tooltip right v-if="savable && material_img">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-bind="attrs"
                              v-on="on"
                              color="secondary"
                              class="pa-2 float-right"
                              @click.stop="removeFromImages(i)"
                            >
                              fa-times
                            </v-icon>
                          </template>
                          <span> {{ $t("Material.delImg") }}</span>
                        </v-tooltip>
                      </v-carousel-item>
                    </v-carousel>
                  </v-card>
                  <v-file-input
                    ref="material_imgs_file"
                    v-if="savable"
                    show-size
                    counter
                    small-chips
                    multiple
                    suffix
                    prepend-icon="fa-camera"
                    accept="image/png, image/jpeg"
                    persistent-hint
                    :placeholder="$t('Material.imgsPlaceholder')"
                    :hint="$t('Material.imgsHint')"
                    :rules="imgsRules"
                    v-model="material_imgs_file"
                  >
                  </v-file-input>
                </v-col>
              </v-row>
              <!-- 商品分类 * -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("Materials.Fields.category") + $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Materials.Fields.category')"
                    rules="required"
                  >
                    <SearcherMaterialCategory
                      v-model="material.material_category"
                      no-label
                      unclearable
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'category_code')
                          .concat(errors)
                      "
                    />
                  </ValidationProvider>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{
                    material && material.material_category
                      ? material.material_category.name
                      : ""
                  }}
                </v-col>
              </v-row>
              <!-- 商品展示分类 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Material.Fields.material_show_categories") +
                    $t("Global.colon")
                  }}
                  <Required :show="false" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <SearcherMaterialShowCategories
                    v-model="material.show_categories"
                    no-label
                  />
                </v-col>
                <v-col cols="9" md="7" v-else>
                  <v-chip
                    v-for="show_category in material.show_categories"
                    :key="show_category.id"
                    small
                    label
                    outlined
                    color="info"
                    class="me-1"
                  >
                    {{
                      show_category.parent_show_category
                        ? show_category.parent_show_category.name + " : "
                        : ""
                    }}
                    {{ show_category.name }}
                  </v-chip>
                </v-col>
              </v-row>
              <!-- 规格 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Materials.Fields.standard_name") + $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <!-- <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('Materials.Fields.standard_name')"
                      rules="required"
                    > -->
                  <v-text-field
                    single-line
                    v-model="material.standard_name"
                    :hint="isNew ? '' : $t('Material.codeHint')"
                  >
                    <template v-slot:message="{ key, message }">
                      <div :class="key == 0 ? 'danger--text' : ''">
                        {{ message }}
                      </div>
                    </template>
                  </v-text-field>
                  <!-- </ValidationProvider> -->
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ material.standard_name }}
                </v-col>
              </v-row>
              <!-- 供货编码 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("Material.Fields.supply_code") + $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-text-field
                    single-line
                    v-model="supplier_material.supply_code"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ supplier_material.supply_code }}
                </v-col>
              </v-row>
              <!-- 供货单价 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("Materials.Fields.price") + $t("Global.colon") }}
                  <Required :show="false" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-text-field
                    single-line
                    v-model="supplier_material.supply_price"
                    type="number"
                    min="0"
                    @blur="
                      supplier_material.supply_price =
                        $numberFormatter.formatMoney(
                          supplier_material.supply_price
                        )
                    "
                    :prefix="$t('Global.money')"
                    :suffix="
                      (supplier_material && supplier_material.standard_detail
                        ? supplier_material.standard_detail.unit
                        : '') +
                      (supplier_material &&
                      supplier_material.standard_detail &&
                      supplier_material.standard_detail.rate != 1
                        ? ' (1' +
                          (supplier_material &&
                          supplier_material.standard_detail
                            ? supplier_material.standard_detail.unit +
                              '=' +
                              supplier_material.standard_detail.rate
                            : '') +
                          (material.standard &&
                          material.standard.default_standard_detail
                            ? material.standard.default_standard_detail.unit
                            : '') +
                          ')'
                        : '')
                    "
                  />
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ $t("Global.money") }} {{ supplier_material.supply_price
                  }}{{
                    (supplier_material && supplier_material.standard_detail
                      ? supplier_material.standard_detail.unit
                      : "") +
                    (supplier_material &&
                    supplier_material.standard_detail &&
                    supplier_material.standard_detail.rate != 1
                      ? " (1" +
                        (supplier_material && supplier_material.standard_detail
                          ? supplier_material.standard_detail.unit +
                            "=" +
                            supplier_material.standard_detail.rate
                          : "") +
                        (material.standard &&
                        material.standard.default_standard_detail
                          ? material.standard.default_standard_detail.unit
                          : "") +
                        ")"
                      : "")
                  }}
                </v-col>
              </v-row>
              <!-- 门店要货价 -->
              <v-row align="center" v-if="accountUser && accountUser.supplier && accountUser.supplier.edit_material_flg">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Materials.Fields.shop_supply_price_default", [
                      $consts.shopName(),
                    ]) + $t("Global.colon")
                  }}
                  <Required :show="false" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-text-field
                    single-line
                    v-model="material.supply_price"
                    type="number"
                    min="0"
                    @blur="
                      material.supply_price = $numberFormatter.formatMoney(
                        material.supply_price
                      )
                    "
                    :prefix="$t('Global.money')"
                    :suffix="
                      (material && material.supply_standard_detail
                        ? material.supply_standard_detail.unit
                        : '') +
                      (material &&
                      material.supply_standard_detail &&
                      material.supply_standard_detail.rate != 1
                        ? ' (1' +
                          (material.supply_standard_detail
                            ? material.supply_standard_detail.unit +
                              '=' +
                              material.supply_standard_detail.rate
                            : '') +
                          (material.standard &&
                          material.standard.default_standard_detail
                            ? material.standard.default_standard_detail.unit
                            : '') +
                          ')'
                        : '')
                    "
                  />
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ $t("Global.money") }} {{ material.supply_price
                  }}{{
                    (material && material.supply_standard_detail
                      ? material.supply_standard_detail.unit
                      : "") +
                    (material &&
                    material.supply_standard_detail &&
                    material.supply_standard_detail.rate != 1
                      ? " (1" +
                        (material.supply_standard_detail
                          ? material.supply_standard_detail.unit +
                            "=" +
                            material.supply_standard_detail.rate
                          : "") +
                        (material.standard &&
                        material.standard.default_standard_detail
                          ? material.standard.default_standard_detail.unit
                          : "") +
                        ")"
                      : "")
                  }}
                </v-col>
              </v-row>
              <!-- 要货倍数 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Materials.Fields.supply_multiple_default") +
                    $t("Global.colon")
                  }}
                  <Required :show="false" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-text-field
                    single-line
                    v-model="material.multiple"
                    type="number"
                    min="0"
                    @blur="
                      material.multiple =
                        $numberFormatter.formatWithDotNoMoreThan(
                          material.multiple,
                          2
                        )
                    "
                    :suffix="$t('Material.multipleEndfix')"
                  />
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ material.multiple }}
                  {{ $t("Material.multipleEndfix") }}
                </v-col>
              </v-row>
              <!-- 最小要货数量 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Materials.Fields.supply_min_default") +
                    $t("Global.colon")
                  }}
                  <Required :show="false" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-text-field
                    single-line
                    v-model="material.min"
                    type="number"
                    min="0"
                    @blur="
                      material.min = $numberFormatter.formatWithDotNoMoreThan(
                        material.min,
                        2
                      )
                    "
                  />
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ material.min }}
                </v-col>
              </v-row>
              <!-- 销售状态 * -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("Materials.Fields.public_flg") + $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-radio-group row v-model="material.public_flg">
                    <v-radio
                      :label="$t('Materials.publicFlgs.off')"
                      :key="0"
                      :value="0"
                    />
                    <v-radio
                      :label="$t('Materials.publicFlgs.on')"
                      :key="1"
                      :value="1"
                    />
                  </v-radio-group>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  <v-chip
                    small
                    label
                    dark
                    :color="material.public_flg ? 'primary' : 'grey'"
                  >
                    {{
                      material.public_flg
                        ? $t("Materials.publicFlgs.on")
                        : $t("Materials.publicFlgs.off")
                    }}
                  </v-chip>
                </v-col>
              </v-row>
              <!-- 商品说明文 -->
              <v-row :class="savable ? 'mt-5' : ''">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("Materials.Fields.description") + $t("Global.colon") }}
                  <Required :show="false" :mode="mode" />
                </v-col>
                <v-col cols="9" md="9" v-if="savable">
                  <v-textarea
                    v-model="material.description"
                    outlined
                    auto-grow
                  />
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ material.description }}
                </v-col>
              </v-row>
              <!-- 视频内容 -->
              <v-row>
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("Materials.Fields.video") + $t("Global.colon") }}
                  <Required :show="false" :mode="mode" />
                </v-col>
                <v-col cols="9" v-show="savable">
                  <v-textarea
                    v-model="material.video"
                    outlined
                    auto-grow
                    rows="3"
                    :hint="$t('Material.videoHint')"
                  >
                    <template v-slot:message="{ key, message }">
                      <div :class="key == 0 ? 'danger--text' : ''">
                        {{ message }}
                      </div>
                    </template>
                  </v-textarea>
                </v-col>
                <v-col cols="9" v-show="!savable" id="material-video"></v-col>
              </v-row>
            </v-container>
          </ValidationObserver>
        </v-card-text>
      </v-card>
      <v-card class="page-opts">
        <v-card-title>
          <v-row dense>
            <v-col cols="12">
              <v-btn
                outlined
                color="secondary"
                class="elevation-1"
                block
                @click="
                  $emit('input', null);
                  $emit('mode', null);
                "
              >
                <v-icon small class="pe-1">fa-times</v-icon>
                {{ $t("CRUD.backToList", [$t("Materials.ObjectName")]) }}
              </v-btn>
            </v-col>
            <v-col
              cols="12"
              v-if="
                isView &&
                $permission.permissionAllow('SupplierMaterials', 'edit')
              "
            >
              <v-btn
                color="accent"
                block
                :disabled="loading && !material.id"
                @click="$emit('mode', 'edit')"
              >
                <v-icon small class="pe-1">fa-pencil-alt</v-icon>
                {{ $t("CRUD.editInfo", [$t("Materials.ObjectName")]) }}
              </v-btn>
            </v-col>
            <v-col cols="12" v-if="savable">
              <!-- 保存 -->
              <v-btn
                color="success"
                block
                :disabled="loading && !material.id"
                @click="save()"
              >
                <v-icon small class="pe-1">fa-save</v-icon>
                {{ $t("CRUD.saveInfo", [$t("Materials.ObjectName")]) }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-sheet>
  </div>
</template>

<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import Consts from "@/consts.js";
import Required from "@/components/plugins/Required";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Materials from "@/api/materials";
import SupplierMaterials from "@/api/supplier_materials";
import Files from "@/api/files";
import SearcherMaterialCategory from "@/components/plugins/SearcherMaterialCategory";
import SearcherMaterialShowCategories from "@/components/plugins/SearcherMaterialShowCategories";

// import SearcherStockArea from "@/components/plugins/SearcherStockArea";

export default {
  props: ["value", "mode"],
  components: {
    Required,
    ValidationObserver,
    ValidationProvider,
    SearcherMaterialCategory,
    SearcherMaterialShowCategories,
    // SearcherStockArea
  },

  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    MaterialImage() {
      if (this.settings && this.settings.material_image == 1) return true;
    },
    isView() {
      return !this.mode || this.mode == "view";
    },
    savable() {
      return this.mode == "edit" || this.mode == "new";
    },
    isNew() {
      return this.mode == "new";
    },
    status() {
      return Consts.stock.status;
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings", "accountUser"]),
  },

  data: () => ({
    serverErrors: [],
    material: {},
    supplier_material: {},
    material_img: "",
    imgRules: [
      (value) => !value || value.size < 5000000 || i18n.t("Material.imgHint"),
    ],
    material_img_file: null,
    imgsRules: [
      (value) =>
        !value ||
        value.filter((v) => v.size >= 10000000).length == 0 ||
        i18n.t("Material.imgsHint"),
    ],
    material_album: [],
    material_imgs_file: [],

    // stockAreasSelected: null
  }),

  mounted() {
    //   if(this.$route.query.stock_id){
    //     this.stock_id = Number(this.$route.query.stock_id)
    //   }
  },

  methods: {
    save() {
      // TODO 检查一下图片上传的error，拒绝上传
      if (
        this.$refs.material_img_file.hasError ||
        this.$refs.material_imgs_file.hasError
      )
        return;

      this.serverErrors = []; //重置远端错误提示
      this.$refs.observer.validate().then(
        async function (result) {
          if (result) {
            this.$store.dispatch("fullscreenLoading");
            // 先尝试提交 单图
            if (this.material_img_file) {
              let response = await Files.imageUploadMaterial(
                this.material_img_file,
                true
              );
              if (response.data.status.isOK()) {
                this.material.material_img = response.data.data.img_name;
                this.material.thumbnail = response.data.data.thumbnail;
              }
            }
            // 再尝试提交 多图
            if (this.material_imgs_file && this.material_imgs_file.length > 0) {
              let response = await Files.imagesUploadMaterials(
                this.material_imgs_file,
                false
              );
              if (response.data.status.isOK()) {
                if (!this.material.material_album)
                  this.material.material_album = [];
                response.data.data.forEach((img) =>
                  this.material.material_album.push(img.img_name)
                );
              }
            }
            this.$store.dispatch("fullscreenLoadingStop");

            //先保存采购价
            SupplierMaterials.batchSave({
              supplier_id: this.supplier_material.supplier_id,
              supplier_material_relations: [
                {
                  material_id: this.supplier_material.material_id,
                  supply_price: this.supplier_material.supply_price,
                  supply_code: this.supplier_material.supply_code,
                },
              ],
            })
              .then(
                function (response) {
                  if (response.data.status.isOK()) {
                    //最后提交商品信息
                    Materials.save(this.material.id, this.material)
                      .then(
                        function (response) {
                          if (response.data.status.isOK()) {
                            this.$emit("save", this.material);
                            this.$emit("mode", null);
                            this.$emit("input", null);
                          } else if (
                            response.data.error &&
                            response.data.error.data &&
                            "ERR333" == response.data.error.code
                          ) {
                            this.serverErrors = response.data.error.data;
                          }
                          this.$store.dispatch("fullscreenLoadingStop");
                        }.bind(this)
                      )
                      .catch(
                        function () {
                          this.$store.dispatch("fullscreenLoadingStop");
                        }.bind(this)
                      );
                  }
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              )
              .catch(
                function () {
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              );
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
    removeFromImages(i) {
      this.material_album.splice(i, 1);
      if (
        this.material.material_album &&
        i < this.material.material_album.length
      ) {
        this.material.material_album.splice(i, 1);
      } else {
        this.material_imgs_file.splice(
          i -
            (this.material.material_album
              ? this.material.material_album.length
              : 0),
          1
        );
      }
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        // console.log(this);
        this.serverErrors = []; //重置远端错误提示
        if (this.value && this.value.id) {
          Materials.fetchOne(this.$route.query.id).then(
            function (response) {
              if (response.data.status.isOK()) {
                // console.log(response);
                this.material = response.data.material;

                // this.stockAreasSelected = this.stock_roadway.stock_area
              }
            }.bind(this)
          );
          SupplierMaterials.fetchOne(this.$route.query.id).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.supplier_material = response.data.material;
                this.supplier_material.supply_price =
                  this.$numberFormatter.formatMoney(
                    this.supplier_material.supply_price
                  );
              }
            }.bind(this)
          );
        } else {
          // 新建仓库，初始化默认值
          this.stock_roadway = {
            // stock_id: this.$route.query.stock_id,
            sort_type: 1,
          };
          //   this.stockAreasSelected = null
        }
        this.$scrollTop(); //返回顶部
      },
    },
    // stockAreasSelected:{
    //     handler(){
    //         this.stock_roadway.stock_area_id = this.stockAreasSelected
    //             ? this.stockAreasSelected.id
    //             : ""
    //     }
    // }
    material: {
      handler() {
        this.serverErrors = []; //重置远端错误提示
        // 重设数据
        // templates TODO
        // this.editUnit = this.isNew;
        this.material_img = this.material.material_img;
        this.material_img_file = null;
        this.material_album = this.material.material_album
          ? JSON.parse(JSON.stringify(this.material.material_album))
          : [];
        this.material_imgs_file = [];
      },
    },
    material_img: {
      handler() {
        if (!this.material_img) {
          this.material_img_file = null;
        }
      },
    },
    material_img_file: {
      handler() {
        if (this.material_img_file) {
          var reader = new FileReader();
          reader.readAsDataURL(this.material_img_file);
          let that = this;
          reader.onload = function () {
            that.material_img = this.result;
          };
        } else {
          this.material_img = this.material.material_img;
        }
      },
    },
    material_imgs_file: {
      handler() {
        if (this.material_imgs_file) {
          this.material_album = this.material.material_album
            ? JSON.parse(JSON.stringify(this.material.material_album))
            : [];
          this.material_imgs_file.forEach((img, i) => {
            var reader = new FileReader();
            reader.readAsDataURL(img);
            let that = this;
            reader.onload = function () {
              that.material_album.splice(
                (that.material.material_album
                  ? that.material.material_album.length
                  : 0) + i,
                0,
                this.result
              );
            };
          });
        } else {
          this.material_album = this.material.material_album
            ? JSON.parse(JSON.stringify(this.material.material_album))
            : [];
        }
      },
    },
  },
};
</script>